import React, { Component } from "react";
import { observer } from "mobx-react";

import {
  fn_delivery_call,
  fn_delivery_cancel,
  fn_show_end_order_cancel,
  fn_print_receipt,
} from "../../../function/FnBodyStep";
import { fn_orderDetailBaemin, fn_connectFailBaemin } from "../../../function/FnBodyLayer";
import {
  fn_bridge_order_change,
  fn_bridge_print,
  fn_bridge_order_detail_baemin,
  fn_bridge_sales_registration,
} from "../../../function/FnPosBridge";
import { baerminUseYn, baeminUsePosNo } from "utils/Utils";

@observer
class BaeminOrderDetailButton extends Component {
  render() {
    const { rootStore, order, type } = this.props;
    const searchStore = rootStore.searchStore;
    /// 조건
    let disableState = false;
    let disableStateN2 = false;
    let disableStateN3 = false;
    let disableStateN4 = false;

    let checkCallBack = order.mobileOrderFg === "29" || order.mobileOrderFg === "30" ? true : false;

    let detailType = "";
    if (
      (searchStore.getCurrStepType === "all" && order.stepType === "READY") ||
      searchStore.getCurrStepType === "ready"
    ) {
      detailType = "ready";
    } else if (
      (searchStore.getCurrStepType === "all" && order.stepType === "COOKING") ||
      searchStore.getCurrStepType === "cooking"
    ) {
      detailType = "cooking";
    } else if (
      (searchStore.getCurrStepType === "all" && order.stepType === "DELIVERY") ||
      searchStore.getCurrStepType === "delivery"
    ) {
      if ((order.dlvStatusFg === null || order.dlvStatusFg === "99") && order.stepCd === "500") {
        detailType = "cooking";
      } else {
        detailType = "delivery";
      }
    } else if (searchStore.getCurrStepType === "end") {
      detailType = "end";
    }
    if (type === "end") {
      detailType = "end";
    }

    if (
      baerminUseYn(rootStore) &&
      rootStore.searchStore.getSession.connPosNo != rootStore.settingStore.getBaeminUseStatus.baeminUsePosNo
    ) {
      disableStateN2 = true;
      disableStateN3 = true;
      disableStateN4 = true;

      if (type == "end" && rootStore.searchStore.getShopCdSaleDate.saleDate != order.saleDate) {
        disableState = true;
      }

      if (detailType === "delivery" && order.orderType === "DELIVERY") {
        if (!order.dlvStatusFg || order.dlvStatusFg === "00") {
          disableStateN3 = false;
        }
      }

      if (detailType === "cooking" && order.orderType === "DELIVERY") {
        disableStateN4 = false;
      }

      if ((detailType === "end" || type === "end") && order.isPartialCanceled) {
        disableStateN3 = false;
      }
    }

    if (order.stepCd === "700" || order.stepCd === "900") {
      if (order.stepCd === "700") {
        disableStateN2 = false;
      } else {
        disableStateN2 = true;
      }
      //disableState = true
    }

    if (detailType === "delivery" && (order.dlvStatusFg == "02" || order.dlvStatusFg == "03")) {
      if (order.mobileOrderFg != "28") {
        disableStateN2 = true;
      } else {
        disableStateN3 = true;
      }
    } else if (detailType === "delivery" && order.dlvStatusFg == "00" && order.baeminDlvType == "BMN") {
      disableStateN3 = true;
    }

    function onClickActionBtn(typeNumber) {
      if (typeNumber === 1) {
        fn_print_receipt(rootStore, order.mobileOrderNo, true); //재출력
      } else if (typeNumber === 2) {
        if (detailType === "ready") {
          baerminUseYn(rootStore)
            ? baeminUsePosNo(rootStore)
              ? fn_bridge_order_detail_baemin(rootStore, order)
              : fn_orderDetailBaemin(rootStore)
            : fn_connectFailBaemin(rootStore, "baemin_connect_fail_reject", order); //주문거절
        } else if (detailType === "cooking") {
          baerminUseYn(rootStore)
            ? baeminUsePosNo(rootStore)
              ? fn_bridge_order_detail_baemin(rootStore, order)
              : fn_orderDetailBaemin(rootStore)
            : fn_connectFailBaemin(rootStore, "baemin_connect_fail_cancel", order);
        } else if (detailType === "delivery") {
          if (order.orderType === "DELIVERY") {
            baerminUseYn(rootStore)
              ? baeminUsePosNo(rootStore)
                ? fn_bridge_order_detail_baemin(rootStore, order)
                : fn_orderDetailBaemin(rootStore)
              : fn_connectFailBaemin(rootStore, "baemin_connect_fail_cancel", order);
          } else {
            if (baerminUseYn(rootStore) && baeminUsePosNo(rootStore)) {
              fn_bridge_order_detail_baemin(rootStore, order);
            } else {
              rootStore.settingStore.getBaeminUseStatus.baeminStatus == "E"
                ? fn_connectFailBaemin(rootStore, "baemin_connect_fail_cancel", order)
                : fn_show_end_order_cancel(rootStore, order.mobileOrderNo, "baemin");
            }
          }
        } else if (detailType === "end") {
          if (order.stepCd === "700") {
            rootStore.layerStore.setLayerAlertType("baemin_order_cancel");
            rootStore.layerStore.setLayerAlertView(true);
          }
          // else{
          //     fn_bridge_order_cancel_pos(rootStore, order)
          // }
        }
      } else if (typeNumber === 3) {
        if (detailType === "cooking") {
          if (order.orderType === "DELIVERY") {
            baerminUseYn(rootStore)
              ? baeminUsePosNo(rootStore)
                ? fn_bridge_order_detail_baemin(rootStore, order)
                : fn_orderDetailBaemin(rootStore)
              : fn_connectFailBaemin(rootStore, "baemin_connect_fail_complete", order); //완료버튼
          } else if (order.orderType === "PICKUP" || order.orderType === "TABLE") {
            baerminUseYn(rootStore)
              ? baeminUsePosNo(rootStore)
                ? fn_bridge_order_detail_baemin(rootStore, order)
                : fn_orderDetailBaemin(rootStore)
              : fn_connectFailBaemin(rootStore, "baemin_connect_fail_complete", order); //완료 포장 & 매장
          }
        } else if (detailType === "delivery") {
          if (!order.dlvStatusFg || order.dlvStatusFg === "00") {
            if (!checkCallBack && order.morderTypeCd != "O") {
              //배민 매장주문 추가로 일단넣음
              fn_delivery_cancel(rootStore, order);
            } else {
              baerminUseYn(rootStore)
                ? baeminUsePosNo(rootStore)
                  ? fn_bridge_order_detail_baemin(rootStore, order)
                  : fn_orderDetailBaemin(rootStore)
                : fn_connectFailBaemin(rootStore, "baemin_connect_fail_complete", order);
            }
          } else {
            fn_bridge_order_detail_baemin(rootStore, order);
          }
        } else if (
          baerminUseYn(rootStore) &&
          (baeminUsePosNo(rootStore) || rootStore.settingStore.getMainPosType == "Y") &&
          (detailType === "end" || type === "end") &&
          order.isPartialCanceled
        ) {
          //부분취소 매출임의등록 조건
          fn_bridge_sales_registration(rootStore);
        }
      } else if (typeNumber === 4) {
        if (detailType === "ready") {
          baerminUseYn(rootStore)
            ? baeminUsePosNo(rootStore)
              ? fn_bridge_order_detail_baemin(rootStore, order)
              : fn_orderDetailBaemin(rootStore)
            : fn_connectFailBaemin(rootStore, "baemin_connect_fail_accept", order);
        } else if (detailType === "cooking") {
          if (order.orderType === "DELIVERY") {
            fn_delivery_call(rootStore, order.mobileOrderNo, "riderCallDetail Button");
          } else if (order.orderType === "PICKUP" || order.orderType === "TABLE") {
            baerminUseYn(rootStore)
              ? baeminUsePosNo(rootStore)
                ? fn_bridge_order_detail_baemin(rootStore, order)
                : fn_orderDetailBaemin(rootStore)
              : fn_connectFailBaemin(rootStore, "baemin_connect_fail_pickupCall", order); //포장, 매장 호출
          } else if (order.orderType === "PICKUP" || order.orderType === "TABLE") {
            fn_bridge_order_detail_baemin(rootStore, order);
          }
        } else if (detailType === "delivery") {
          baerminUseYn(rootStore)
            ? baeminUsePosNo(rootStore)
              ? fn_bridge_order_detail_baemin(rootStore, order)
              : fn_orderDetailBaemin(rootStore)
            : fn_connectFailBaemin(
                rootStore,
                checkCallBack ? "baemin_connect_fail_ready" : "baemin_connect_fail_complete",
                order
              );
        } else if (detailType === "end" || type === "end") {
          baerminUseYn(rootStore)
            ? baeminUsePosNo(rootStore)
              ? fn_bridge_order_detail_baemin(rootStore, order)
              : fn_orderDetailBaemin(rootStore)
            : fn_connectFailBaemin(rootStore, "baemin_connect_fail_complete", order);
        } else {
          return null;
        }
      }
    }
    function btnTypeTxt(typeNumber) {
      if (typeNumber === 1) {
        return <span className="txt">재출력</span>;
      } else if (typeNumber === 2) {
        if (detailType === "ready") {
          return <span className="txt">주문거부</span>;
        } else if (detailType === "cooking" || detailType === "delivery") {
          return <span className="txt">주문취소</span>;
        } else if ((detailType === "end" || type === "end") && order.stepCd === "700") {
          return <span className="txt">주문취소</span>;
        } else {
          return <span className="txt">주문취소</span>;
        }
      } else if (typeNumber === 3) {
        // BMPC LITE: 배민1(29), 배민스토어(30 배달 주문 중 STEP CD = 200경우 배민 상세보기
        if (
          (order.mobileOrderFg === "29" || order.mobileOrderFg === "30") &&
          order.orderType === "DELIVERY" &&
          parseInt(order.stepCd) >= 200 &&
          parseInt(order.stepCd) <= 500
        ) {
          return <span className="txt">배민 상세보기</span>;
        }

        if (detailType === "cooking") {
          if (!checkCallBack) {
            return <span className="txt">완료처리</span>;
          }
        } else if (detailType === "delivery") {
          if (order.orderType === "DELIVERY") {
            if (
              !order.dlvStatusFg ||
              order.dlvStatusFg === "00" ||
              order.dlvStatusFg === "02" ||
              order.dlvStatusFg === "03"
            ) {
              if (!checkCallBack) {
                return <span className="txt">배차취소</span>;
              } else if (order.mobileOrderFg === "29" && order.partnerEtcInfo != "COOK_COMPLETED") {
                return <span className="txt">준비완료</span>;
              }
            }
          } else if (order.orderType === "PICKUP" || order.orderType === "TABLE") {
            return <span className="txt">완료처리</span>;
          }
        } else if (
          baerminUseYn(rootStore) &&
          (baeminUsePosNo(rootStore) || rootStore.settingStore.getMainPosType == "Y") &&
          (detailType === "end" || type === "end") &&
          order.isPartialCanceled
        ) {
          return <span className="txt">매출 임의 등록</span>;
        }
      } else if (typeNumber === 4) {
        // BMPC LITE: 배민1(29), 배민스토어(30 배달 주문 중 STEP CD = 200~500인 경우 기존 버튼3 내용을 버튼4로 이동
        if (
          (order.mobileOrderFg === "29" || order.mobileOrderFg === "30") &&
          order.orderType === "DELIVERY" &&
          parseInt(order.stepCd) >= 200 &&
          parseInt(order.stepCd) <= 500
        ) {
          if (detailType === "cooking") {
            if (!checkCallBack) {
              return <span className="txt">완료처리</span>;
            }
          } else if (detailType === "delivery") {
            if (order.orderType === "DELIVERY") {
              if (
                !order.dlvStatusFg ||
                order.dlvStatusFg === "00" ||
                order.dlvStatusFg === "02" ||
                order.dlvStatusFg === "03"
              ) {
                if (!checkCallBack) {
                  return <span className="txt">배차취소</span>;
                } else if (order.mobileOrderFg === "29" && order.partnerEtcInfo != "COOK_COMPLETED") {
                  return <span className="txt">준비완료</span>;
                }
              }
            }
          } else if (order.orderType === "PICKUP" || order.orderType === "TABLE") {
            return <span className="txt">완료처리</span>;
          }
        }

        if (detailType === "ready") {
          return <span className="txt">주문접수</span>;
        } else if (detailType === "cooking") {
          if (order.orderType === "DELIVERY") {
            if (checkCallBack) {
              return <span className="txt">준비완료</span>;
            } else {
              return <span className="txt">배달요청</span>;
            }
          } else if (order.orderType === "PICKUP" || order.orderType === "TABLE") {
            return (
              <>
                <div className="txt">호출</div>
                <div className="more">(픽업요청 알림발송)</div>
              </>
            );
          }
        } else if (detailType === "delivery") {
          if (order.orderType === "DELIVERY") {
            if (!checkCallBack) {
              return <span className="txt">배달완료</span>;
            } else if (order.mobileOrderFg === "29" && order.partnerEtcInfo === "COOK_COMPLETED") {
              return <span className="txt">준비완료</span>;
            } else if (order.mobileOrderFg == "30" && (order.dlvStatusFg === "00" || order.dlvStatusFg === "01")) {
              return <span className="txt">준비완료</span>;
            }
          } else {
            return (
              <>
                <div className="txt">호출</div>
                <div className="more">(픽업요청 알림발송)</div>
              </>
            );
          }
        } else if (baerminUseYn(rootStore) && baeminUsePosNo(rootStore) && (detailType === "end" || type === "end")) {
          return <span className="txt">배민 상세 보기</span>;
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
    const rendering = () => {
      const result = [];
      for (let i = 1; i < 5; i++) {
        if (btnTypeTxt(i) != null) {
          result.push(
            <li key={i}>
              <button
                type="button"
                onClick={() => onClickActionBtn(i)}
                className={detailType === "end" || type === "end" ? "btn btn_type" + i + " baemin" : "btn btn_type" + i}
                disabled={
                  i == 1
                    ? disableState
                    : i == 3 && disableStateN3
                    ? disableStateN3
                    : i == 2 && disableStateN2
                    ? disableStateN2
                    : i == 4 && disableStateN4
                    ? disableStateN4
                    : false
                }
              >
                <span className={order.partnerEtcInfo == "COOK_COMPLETED" && i == 4 ? "checkTxt" : ""}>
                  {btnTypeTxt(i)}
                </span>
                {order.partnerEtcInfo == "COOK_COMPLETED" && !(order.stepCd == "700" || order.stepCd == "900") ? (
                  <span className="checkIco"></span>
                ) : null}
              </button>
            </li>
          );
        }
      }
      return result;
    };
    /// 조건 끝
    return (
      <div className="section_btn">
        <ul>{rendering()}</ul>
      </div>
    );
  }
}

export default BaeminOrderDetailButton;
